const imagesUser = [
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/astronaut_skull_in_cosmic_space.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/astronaut_skull_in_space.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/cloaked_figure_in_misty_city.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/dog_survivor_in_ruined_city.png", 
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/spectral_astronaut_with_stellar_backdrop.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/ghost_in_mirror.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/astronaut_gazing_into_space.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/cosmic_astronaut_with_vibrant_hues.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/ominous_deep-sea_fish_lurking.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/shattered_chains_and_skeleton_hands.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/silhouette_in_abandoned_building.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/soldier_walking_through_battlefield_aftermath.png",
  "https://generative-ai-ultisaer.s3.sa-east-1.amazonaws.com/images/samurai_dog_at_sunset_overlook.png"
]

const imagesBackgrounds = imagesUser.slice(0, 5)
const imagesIcons = imagesUser.slice(5, 14)

export { imagesBackgrounds, imagesIcons }